import filterOutExcludedColumns from "../CoreHelpers/filterOutExcludedColumns";
import DataInterceptorBase from "../DataInterceptorBase";
import { UniversalTableQuery } from "../UniversalTableQueryBuilder";
import appendQueryStringToUrl from "../../url/appendQueryStringToUrl";

export type FetchConfigParams = {
  urlPath?: string,
  urlPathWithSettings?: string,
  excludedColumnsByAttributeName?: string[]
};
export type FetchTabWithOptionsParams = { urlPath?: string, url?: string };

export default class DefaultDataInterceptor extends DataInterceptorBase {
  async fetchConfig(id, defaultSettings, params: FetchConfigParams) {
    let settings = null;

    if (defaultSettings) {
      settings = new UniversalTableQuery()
        .addFilters(defaultSettings.filters, [])
        .toString();
    }

    const config = await this.makeRequest({
      urlPath: settings
        ? params?.urlPathWithSettings ?? "app.csvData.configWithSettings"
        : params?.urlPath ?? "app.csvData.config",
      variables: {
        id,
        settings
      }
    });

    filterOutExcludedColumns(config, params?.excludedColumnsByAttributeName);

    return config;
  }

  async fetchTabWithOptions(
    id,
    currentTabId,
    tableState,
    params: FetchTabWithOptionsParams
  ) {


    this.queryBuilder.setTableState(tableState);
    const queryParams = this.queryBuilder.getQueryParams();
    const requestUrl = params?.url
      ? appendQueryStringToUrl(params.url, queryParams)
      : null;

    return await this.makeRequest({
      ...(requestUrl
        ? { url: requestUrl }
        : { urlPath: params?.urlPath ?? "app.csvData.tabWithOptions" }),
      variables: {
        id,
        tabId: currentTabId,
        options: queryParams
      }
    });
  }

  async fetchNextPage(url) {
    return await this.makeRequest({ url });
  }
}
